import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

import Swal from "sweetalert2";
import * as _ from 'underscore';
import {VnaCampaignService} from '../../services/vna-campaign.service';
import {ModalExtended} from 'ngx-dynamic-modal';
import {DatesParserService} from '../../../../../core/service/dates_parser.service';
import {PortalTimezoneService} from '../../../vna_portal/services/portal-timezone.service';
import {AuthService} from '../../../../../core/service/auth.service';

@Component({
  selector: 'app-vna-campaign-action-edit',
  templateUrl: './vna-campaign-action-edit.component.html',
  styleUrls: ['./vna-campaign-action-edit.component.scss']
})
export class VnaCampaignActionEditComponent extends ModalExtended implements OnInit {

    enclosureTypes: Array<Object> = [];
    delimiterTypes: Array<Object> = [];
    formData: FormGroup;
    data: any;

    submitted: boolean = false;
    enabled: boolean = false;

    file: File;

    errors: Object = {};

    fromHr:any;

    constructor(private campHandler: VnaCampaignService, private datesParser: DatesParserService) {
        super();

        let from= new Date();
        from.setHours(0,0,0,0);
        this.fromHr=from;

        this.enclosureTypes=[
            {value: "DOUBLE_QUOTE", label: 'Double Quote '+ '( \" )'},
            {value: "SIMPLE_QUOTE", label: 'Single Quote '+'( \' ) ' },
            {value: "EMPTY", label: 'Empty'}
        ];

        this.delimiterTypes=[
            {value: ";", label: 'Dot and comma' + ' ( ; )' },
            {value: ",", label: 'Comma' + ' ( , )' },
            {value: "TAB", label: 'Tab' + ' ( )' },
            {value: "|", label:'Pipe' + ' ( | )' },
            {value: "~|~", label: 'Special type'+ ' ( | )' }
        ];

        this.formData = new FormGroup({
            type: new FormControl('', Validators.required),
            start_at: new FormControl(''),
            name: new FormControl(''),
            lang: new FormControl('', Validators.required),
            enclosure: new FormControl(''),
            delimiter: new FormControl(''),
            active: new FormControl('0'),
            timezone: new FormControl('', Validators.required),
            actions: new FormControl(),
            config: new FormGroup({
                pkg_users: new FormControl('10'),
                time_between_pkgs: new FormControl('120'),
                phone_column_name: new FormControl(),
                check_already_verifieds: new FormControl('0'),
                check_already_verifieds_days: new FormControl({value: '', disabled: true}),
                reset_phone_attempts: new FormControl('0'),
                create_report: new FormControl('0'),
                extra_camps_already_verifieds: new FormControl()
            }),
            requests_hit: new FormControl('', Validators.pattern(/^[0-9]{1,}$/))
        });
    }

    onExit(){
        this.applyCallback({'reload_actions' : true});
        this.close();
    }

    onAction(event): void {
        (event.currentFiles.length > 0)
            ? this.file = event.file
            : this.file = null
        ;

    }

    updateAction(): void {

        this.submitted = false;
        if(!this.checkForm()){
            return;
        }

        this.enabled = true;
        var formValues = this.datesParser.cleanDates(Object.assign({}, this.formData.value), ['start_at'], false);
        formValues = this.checkExtraConfig(formValues);
        this.campHandler.updateAction(this.data['pk'], formValues, this.file).subscribe(
            (result) => {
                if(result.hasOwnProperty('errors')){
                    this.errors = result.errors
                }
                else{
                    Swal({ type : 'success', title: 'Action performed', text: 'Campaign action has been updated successfully'});
                    this.errors = {};
                }

                this.enabled = false;
            }
        );
    }

    createAction(): void {

        this.submitted = false;
        if(!this.checkForm()){
            return;
        }

        this.enabled = true;
        let formValues = this.datesParser.cleanDates(Object.assign({}, this.formData.value), ['start_at'], false);
        formValues = this.checkExtraConfig(formValues);
        this.campHandler.createAction(this.data['pk_camp'], formValues, this.file).subscribe(
            (result) => {
                if(result.hasOwnProperty('errors')){
                    this.errors = result.errors
                }
                else{
                    Swal({ type : 'success', title: 'Action performed', text: 'Campaign action has been created successfully'});
                    this.errors = {};
                }

                this.enabled = false;
            }
        );
    }

    checkAlreadyVerifiedsValue(event: any): void {
        if (event.target.checked){
            this.formData.controls['config']['controls']['check_already_verifieds_days'].enable();
        }
        else{
            this.formData.controls['config']['controls']['check_already_verifieds_days'].setValue('');
            this.formData.controls['config']['controls']['check_already_verifieds_days'].disable();
        }
    }

    ngOnInit() {
        if(this.data.hasOwnProperty('pk')){
            this.formData.controls['type'].setValue(this.data['type']);
            this.formData.controls['start_at'].setValue(this.data['start_at']);
            this.formData.controls['lang'].setValue(this.data['lang']);
            this.formData.controls['enclosure'].setValue(this.data['enclosure']);
            this.formData.controls['delimiter'].setValue(this.data['delimiter']);
            this.formData.controls['active'].setValue(this.data['active']);
            this.formData.controls['timezone'].setValue(this.data['timezone']);
            this.formData.controls['requests_hit'].setValue(this.data['requests_hit']);

            if(this.data.config.hasOwnProperty('pkg_users')){
                this.formData.controls['config']['controls']['pkg_users'].setValue(this.data.config.pkg_users);
            }

            if(this.data.config.hasOwnProperty('time_between_pkgs')){
                this.formData.controls['config']['controls']['time_between_pkgs'].setValue(this.data.config.time_between_pkgs);
            }

            if(this.data.config.hasOwnProperty('phone_column_name')){
                this.formData.controls['config']['controls']['phone_column_name'].setValue(this.data.config.phone_column_name);
            }

            if(this.data.config.hasOwnProperty('check_already_verifieds')){
                this.formData.controls['config']['controls']['check_already_verifieds'].setValue(this.data.config.check_already_verifieds);
            }

            if(this.data.config.hasOwnProperty('check_already_verifieds_days')){
                this.formData.controls['config']['controls']['check_already_verifieds_days'].setValue(this.data.config.check_already_verifieds_days);
            }

            if(this.data.config.hasOwnProperty('reset_phone_attempts')){
                this.formData.controls['config']['controls']['reset_phone_attempts'].setValue(this.data.config.reset_phone_attempts);
            }

            if(this.data.config.hasOwnProperty('create_report')){
                this.formData.controls['config']['controls']['create_report'].setValue(this.data.config.create_report);
            }

            if(this.data.config.hasOwnProperty('extra_camps_already_verifieds')
              && this.data.config['extra_camps_already_verifieds'].length > 0) {
                this.formData.controls['config']['controls']['extra_camps_already_verifieds']
                .setValue(this.data.config['extra_camps_already_verifieds']);
            }
        }
    }

    protected checkForm(): boolean {

        if(!this.file && this.formData.value.type == 'FILE'){
            Swal({ 'type' : 'warning', 'title' : 'Review you data', 'text' : 'You must add at least one file' });
            return false;
        }

        if(!this.formData.valid){
            this.submitted = true;
            return false;
        }

        return true;
    }

    protected checkExtraConfig(formValues: any): any {
      if(formValues.hasOwnProperty('config') && _.isArray(formValues['config'].extra_camps_already_verifieds)) {
        formValues['config'].extra_camps_already_verifieds = formValues['config'].extra_camps_already_verifieds.map((o: any) => {
          return o.pk;
        });
      }

      return formValues;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/modals/vna-campaign-action-edit/vna-campaign-action-edit.component.ts